module.exports = {
	data() {
		return {
			scrollPosition: window.pageYOffset
		}
	},

	methods: {
  		updateScrollPosition() {
  			this.scrollPosition = window.pageYOffset;
  		}
	},

	mounted() {
		window.addEventListener('scroll', this.updateScrollPosition);
	},

	destroyed () {
	  window.removeEventListener('scroll', this.updateScrollPosition);
	}
}
